import React from 'react';

interface Props {
    className?: string;
}

export const QuestionMessagesIcon: React.FC<Props> = ({ className }) => {
    return (
        <svg className={`icon${className ? ` ${className}` : ''}`} width="20" height="20" viewBox="0 0 20 20">
            <path
                d="M10,0.6C3.8,0.6,0,1.9,0,8.1s3.8,7.5,10,7.5c1.1,0,2.1,0,3.1-0.1l3.4,3.9l1.7-5.8c1.2-1.1,1.9-2.9,1.9-5.4
                C20,1.9,16.2,0.6,10,0.6z M16.6,11.9l-0.4,0.4l-0.7,2.5L14,13.1l-1.2,0.1C12,13.3,11,13.3,10,13.3c-6.7,0-7.8-1.6-7.8-5.3
                S3.3,2.8,10,2.8s7.8,1.6,7.8,5.3C17.8,9.9,17.4,11.2,16.6,11.9z"
            />
            <path
                d="M10.9,7.2c0.4-0.2,0.5-0.6,0.5-1c0-0.3-0.1-0.6-0.4-0.8c-0.2-0.2-0.6-0.3-1-0.3c-0.4,0-0.7,0.1-1,0.2
                C8.6,5.5,8.3,5.7,8.1,6l-0.9-1c0.4-0.4,0.8-0.7,1.2-1c0.5-0.2,1-0.4,1.7-0.4c0.4,0,0.8,0.1,1.1,0.2c0.3,0.1,0.6,0.3,0.9,0.5
                s0.4,0.5,0.6,0.8c0.1,0.3,0.2,0.6,0.2,1c0,0.4-0.1,0.7-0.2,1c-0.1,0.3-0.3,0.5-0.5,0.7c-0.2,0.2-0.5,0.3-0.8,0.5
                c-0.3,0.1-0.6,0.2-0.9,0.3l-0.1,1h-1L9.1,7.7l0.1-0.1C9.9,7.6,10.5,7.4,10.9,7.2z M9,12.3v-1.6h1.6v1.6H9z"
            />
        </svg>
    );
};
